import * as Sentry from "@sentry/sveltekit";

// Client-side-only Sentry setup — this is a static SPA (adapter-static), so
// there is no SSR and no hooks.server.ts / instrumentation.server.ts.
//
// The DSN is injected at build time from the VITE_SENTRY_DSN env var
// (GitHub Actions secret `SENTRY_DSN` in CI; `.env` locally). When it's
// unset, Sentry logs a debug warning and simply doesn't send events, so
// local dev builds without a DSN still work.
Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	// Set tracesSampleRate to 1.0 to capture 100% of transactions for
	// tracing. We recommend adjusting this value in production.
	tracesSampleRate: 1.0,
	// 'production' for `vite build`, 'development' for `vite dev`.
	environment: import.meta.env.MODE,
});

export const handleError = Sentry.handleErrorWithSentry();
